export const mutations = {
  STORE_OCCUPATIONS(state, occupations) {
    state.occupations = occupations;
  },

  STORE_OCCUPATION_UPDATE(state, occupationId) {
    let Occupation = state.occupations.find(function(occupation) {
      return occupation.id === occupationId;
    });
    state.systemOccupation = Occupation;

  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/occupations/mutations.js